<template>
  <van-popup v-model="showPage" position="top" :overlay="false" class="progressTopInfo">
    <van-row class="popTitle">
      <van-col span="4" />
      <van-col span="16" class="center" :style="'color:'+GetDiveMainBack()">进度详情</van-col>
      <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showPage =false" /></van-col>
    </van-row>
    <div class="dataRect">
      <van-row v-if="selectProgressInfo" gutter="10" class="values breakAll">
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">顾客: </span>{{ selectProgressInfo.member.lastName+' '+selectProgressInfo.member.firstName }}</van-col>
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">项目: </span>{{ selectProgressInfo.unit.unitName }}</van-col>
      </van-row>
      <van-row v-if="selectProgressInfo && selectProgressInfo.progress" gutter="10" class="values breakAll">
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">评分: </span>{{ GetEnumText('Em_CompletionState',selectProgressInfo.progress.completionState) }}</van-col>
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">状态: </span><b>{{ GetEnumText('Em_DiveUnitState',selectProgressInfo.progress.state) }}</b></van-col>
      </van-row>
      <van-row v-if="selectProgressInfo && selectProgressInfo.progress" gutter="10" class="values breakAll">
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">发布: </span>{{ formatDate(selectProgressInfo.progress.createTime,'yyyy/MM/dd hh:mm') }}</van-col>
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">更新: </span>{{ formatDate(selectProgressInfo.progress.lastTime,'yyyy/MM/dd hh:mm') }}</van-col>
      </van-row>
      <van-row v-if="selectProgressInfo && selectProgressInfo.progress" gutter="10" class="values breakAll">
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">教练: </span>{{ selectProgressInfo.progress.coachName }}</van-col>
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()" /></van-col>
      </van-row>
      <van-row v-if="selectProgressInfo && selectProgressInfo.progress" gutter="10" class="values breakAll">
        <van-col span="24"><span :style="'color:'+GetDiveMainBack()">评语: </span>{{ selectProgressInfo.progress.comment }}</van-col>
      </van-row>
    </div>
  </van-popup>
</template>
<script>
import { Button, Popup, Field, Dialog, RadioGroup, Radio, Checkbox } from 'vant'
import { formatDate, GetEnumText, MyNotify, getScoreText, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox
  },
  props: {
    // eslint-disable-next-line
    value: Boolean,
    // eslint-disable-next-line
    selectProgressInfo:undefined
  },
  data() {
    return {
      showPage: false
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showPage = true
      } else {
        this.showPage = false
      }
    }

  },
  created() {
  },
  methods: {
    formatDate,
    GetEnumText,
    MyNotify,
    getScoreText,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetColorMainLine,
    onClosed() {
      console.log('onClosed')
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>
.progressTopInfo{
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}
.progressTopInfo .dataRect
{
  padding: 0 0.5em;
  overflow: hidden;
  font-size: 0.8em;
  line-height: 1.5em;
}
.progressTopInfo .editRect
{
  padding-top: 0.5em;
  padding-bottom: 1em;
  line-height: 2.5em;
}
.progressTopInfo .popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}

</style>
